import React from "react"
import Relay from "react-relay"
import PropTypes from "prop-types"
import { initTileMap } from "../../scripts/mapBox"
import ImageView from "./ImageView"
import MediaMissing from "./MediaMissing"

class MapView extends React.Component {
  // Temp until I can get this from the resource
  _map = null

  static propTypes = {
    resource: PropTypes.object.isRequired,
    mapRef: PropTypes.func,
    width: PropTypes.string,
    height: PropTypes.string
  }

  static defaultProps = {
    width: "100%",
    height: "100%"
  }

  componentDidMount() {
    this.initMap()
  }

  componentWillUnmount() {
    if (this._map) {
      this._map.remove()
    }
  }

  componentWillReceiveProps(nextProps) {
    const { map_url: mapUrl } = JSON.parse(this.props.resource.custom_fields)
    const { map_url: nextMapUrl } = JSON.parse(nextProps.resource.custom_fields)

    if ((mapUrl ? mapUrl.value : "") !== (nextMapUrl ? nextMapUrl.value : "")) {
      this.initMap(nextProps)
    }
  }

  withMapRef = () =>
    new Promise(resolve => {
      if (this.mapContainer) resolve(this.mapContainer)
      else {
        setTimeout(() => resolve(this.withMapRef()), 100)
      }
    })

  initMap = props => {
    const { mapRef, resource } = props || this.props
    const { map_url: mapUrl } = JSON.parse(resource.custom_fields)

    if (this._map) {
      this._map.remove()
    }
    this.withMapRef().then(container => {
      initTileMap({ container }, mapUrl.value).then(map => {
        if (mapRef) {
          this._map = map
          mapRef(map)
        }
      })
    })
  }

  render() {
    const { width, height, resource } = this.props
    const { map_url: mapUrl } = JSON.parse(resource.custom_fields)

    return mapUrl && mapUrl.value ? (
      <div style={{ width, height }} ref={el => (this.mapContainer = el)} />
    ) : (
      <ImageView
        resource={resource}
        withDeepZoom={true}
        imgClassName="state-canvas-contain"
        ifNoImage={<MediaMissing resource={resource} />}
      />
    )
  }
}

export default Relay.createContainer(MapView, {
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
        custom_fields
        ${ImageView.getFragment("resource")}
        ${MediaMissing.getFragment("resource")}
    }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/MapView.js